import gql from 'graphql-tag';

export const GET_TREADWELL_DRIVER_PERSONA_OPTIONS = gql`
  query personaOptions($fuelType: FuelType!, $vehicleCategory: VehicleCategory!) {
    recommendationQueries {
      treadwellCustomPriorities(fuelType: $fuelType) {
        name
        id
        position
        cmsComponents {
          name
          id
          typeName
          ... on CmsPromotionBannerComponent {
            dynamicImagePath
            imageUrl
            imageAltText
            imageTarget
          }
        }
      }

      treadwellPersonas(fuelType: $fuelType, vehicleCategoryClass: $vehicleCategory) {
        description
        contentSlots {
          name
          id
          position
          cmsComponents {
            name
            typeName
            id
            ... on CmsToolTipsComponent {
              name
              icon
              description
              typeName
              tipslisttype
              tooltips {
                tipText
                id
                title
              }
            }
          }
        }
      }
    }
  }
`;
